exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-autocomplete input[data-v-7240b9a1] {\n  padding-left: 50px !important;\n}", ""]);

// exports
